module.exports = __webpack_public_path__ + "img/icon_mall.da51f6ac.png";